<div *ngIf="!isLoading; else loading">
  <div
    dgxSticky
    [notStickyMobile]="true"
    [stickyCustomClass]="'box-shadow bg-color-white'"
    class="dg-sticky border-bottom bg-color-white"
    [ngClass]="{ 'dg-sticky--toggle-title': toggleTitle }"
  >
    <div
      class="grid center-item"
      [ngStyle]="{ 'max-width': !isChannel ? '94rem' : '96rem' }"
    >
      <!-- width difference between channel and main app -->
      <div
        class="grid__col-sm-4 font-medium l_flex-center guts-p-l-0 m-guts-p-l-1"
      >
        <h3 class="h3 dg-sticky__title">{{ i18n.Core_Permissions }}</h3>
      </div>
      <div
        *ngFor="let role of roles; trackBy: trackRoleById"
        class="grid__col-sm-auto grid__col--bleed guts-p-v-1-half font-medium no-mobile l_flex-center center-text"
        data-dgat="org-security-58e"
      >
        {{ role.labelKey | translate }}
      </div>
    </div>
  </div>
  <ng-container
    *ngFor="
      let availablePermission of availablePermissions;
      trackBy: trackPermissionById;
      index as $index
    "
    data-dgat="org-security-7dd"
  >
    <div
      *ngIf="roles && availablePermission.name && availablePermission.labelKey"
      class="grid grid--bleed guts-p-v-1-half m-guts-p-v-2"
      [ngClass]="{
        'bg-color-ebony-a03': availablePermission.nested,
        'border-bottom': !availablePermission.nested,
        'border-top':
          !availablePermission.nested &&
          availablePermissions[$index - 1]?.nested,
      }"
      data-dgat="orgSecurity-40a"
    >
      <div
        class="grid__col-12 grid__col-sm-4 guts-p-l-0 m-guts-p-l-1 m-guts-p-b-1"
        [ngClass]="{ 'guts-p-l-3 m-guts-p-l-1': availablePermission.nested }"
      >
        <dgx-toggle-element
          [buttonText]="availablePermission.labelKey | translate"
          ><span class="color-ebony-a61 zeta">{{
            availablePermission.descriptionKey | translate
          }}</span>
          <span
            class="guts-m-l-half"
            *ngIf="canViewKnowledgeCenter && availablePermission.learnMoreLink"
          >
            <a
              rel="noopener noreferrer"
              (click)="clickedLearnMoreLink(availablePermission.learnMoreLink)"
              [href]="availablePermission.learnMoreLink"
              class="link zeta"
              data-dgat="orgSecurity-2c9"
              >{{ i18n.dgOrgSecurity_LearnMore }}</a
            >
          </span>
        </dgx-toggle-element>
      </div>
      <div
        *ngFor="let role of roles; trackBy: trackRoleById"
        class="grid__col-12 grid__col-sm-auto l_flex-center center-text m-left-text font-medium"
        data-dgat="orgSecurity-1f2"
      >
        <ng-container
          *ngFor="
            let permission of role.permissions;
            trackBy: trackPermissionById
          "
          data-dgat="org-security-a0b"
        >
          <div
            *ngIf="
              permission.name === availablePermission.name &&
              availablePermission.id !== 'CreateGroups' &&
              availablePermission.id !== 'CreateOpportunities' &&
              availablePermission.id !== 'UploadFiles' &&
              availablePermission.id !== 'ManageReporting'
            "
            data-dgat="orgSecurity-bb9"
            class="m-guts-p-h-1"
          >
            <label title="{{ permission.descriptionKey | translate }}"
              ><input
                [disabled]="permission.isDisabled"
                type="checkbox"
                [(ngModel)]="permission.assigned"
                (change)="updateRoles(roles)"
                data-dgat="orgSecurity-927"
                [attr.aria-label]="role.labelKey | translate"
              />
              <span class="a11y-hide mobile-only ib">{{
                role.labelKey | translate
              }}</span></label
            >
          </div>
        </ng-container>
      </div>
    </div>
  </ng-container>
  <div class="guts-p-v-half m-guts-p-h-1">
    <div class="guts-m-v-half">
      <p>
        <span class="font-medium par--light">{{
          i18n.dgOrgSecurity_DefaultRoleText
        }}</span>
      </p>
    </div>
  </div>
</div>

<!-- Loading template -->
<ng-template #loading>
  <dgx-skeleton
    type="permission"
    [rows]="10"
    [columns]="5"
    class="guts-m-v-2"
  ></dgx-skeleton>
</ng-template>
